type ArrowSmallLineProps = {
  /** apply fill-{color} class to change color*/
  className?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
};
const ArrowSmallLine = ({
  className,
  width = 24,
  height = 24,
  strokeWidth = 2,
}: ArrowSmallLineProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 17L15 12L10 7"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowSmallLine;
